const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? ""

if (!API_BASE_URL && import.meta.env.MODE !== "test") {
  throw new Error("VITE_API_BASE_URL is not defined")
}

const join = (path: string) => `${API_BASE_URL.replace(/\/$/, "")}/${path.replace(/^\//, "")}`

export const endpoints = {
  accountAccess: {
    list: join("account-access"),
    employees: join("account-access/employees"),
    learner: join("account-access/learner"),
  },
  account: {
    me: join("me"),
    learning: join("me/learning"),
    access: join("learner-access"),
    invitations: join("learner-invitations"),
  },
  // Health Check
  status: {
    healthDb: join("health/db"),
  },

  // Admin Users
  admin: {
    list: join("admin"),
    update: join("admin"),
    delete: join("admin"),
    invitations: join("admin/invitations"),
    invite: join("admin/invite"),
  },

  // Users (Employees)
  users: {
    list: join("users"),
    get: join("users"),
    resolvePartner: join("users/partners"),
    create: join("users"),
    update: join("users"),
    delete: join("users"),
    toggleStatus: join("users"),
    exportCsv: join("users/export-csv"),
  },

  // Import (CSV bulk operations)
  import: {
    usersCsv: join("import/users-csv"),
    usersCsvPreview: join("import/users-csv-preview"),
    userJobNumbers: join("import/user-job-numbers"),
    certificationsCsv: join("import/certifications-csv"),
    coursesCsv: join("import/courses-csv"),
  },

  // Certifications (note: API uses "certifications" not "certificates")
  certifications: {
    list: join("certifications"),
    create: join("certifications"),
    update: join("certifications"),
    delete: join("certifications"),
    byUser: join("certifications/user"),
  },

  // Courses
  courses: {
    list: join("courses"),
  },

  grow: {
    workQueue: join("grow/work-queue"),
    manage: join("grow/manage"),
    candidates: join("grow/candidates"),
    learnerLinks: join("grow/learner-links"),
    courseLinks: join("grow/course-links"),
    courseImports: join("grow/course-imports"),
    policies: join("grow/policies"),
    historicalEdits: join("grow/historical-edits"),
    removals: join("grow/removals"),
    reviews: join("grow/reviews"),
    state: join("grow/state"),
    resync: join("grow/resync"),
  },

  // Upload (images/documents)
  upload: {
    avatar: join("upload/avatar"),
    deleteAvatar: join("upload/avatar"),
    certification: join("upload"),
    deleteImage: join("upload/image"),
  },

  // Organizations
  organizations: {
    list: join("organizations"),
  },

  // QR Print Logs
  qrPrintLogs: {
    list: join("qr-print-log"),
    create: join("qr-print-log"),
    byUser: join("qr-print-log/user"),
  },
  // QR Codes
  qrCodes: {
    list: join("qr-codes"),
    generate: join("qr-codes/generate"),
    assign: join("qr-codes/assign"),
    unassign: join("qr-codes/unassign"),
    resolve: join("qr-codes/resolve"),
    byUser: join("qr-codes/user"),
  },
} as const

export type Endpoints = typeof endpoints
